import { useEffect, useRef } from 'react';
import { API_BASE_URL } from '../services/api';
import { getLocalDateString } from '../utils/date';

export function useAutoSupplements() {
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    const autoMark = localStorage.getItem('fueltron_autoMarkSupps') === 'true';
    if (!autoMark) return;

    const token = localStorage.getItem('token');
    if (!token) return;

    ranRef.current = true;

    // The device's calendar day. The UTC date used before was already
    // tomorrow after 8pm Eastern, so auto-mark ticked off tomorrow's doses.
    const today = getLocalDateString(new Date());

    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/supplements-new/schedule/${today}`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        const data = await res.json();
        if (!data.success) return;

        const pending = (data.data.schedule || []).filter((item: any) => !item.taken);
        if (pending.length === 0) return;

        await Promise.all(pending.map((item: any) =>
          fetch(`${API_BASE_URL}/supplements-new/intake`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
              regimenId: item.regimenId,
              timeOfDay: item.timeOfDay,
              date: today, // the device's calendar day — the server stamps the row on it
              dateTaken: new Date(today + 'T00:00:00').toISOString()
            })
          })
        ));
      } catch {
        // Silent — supplements page will still work as fallback
      }
    })();
  }, []);
}
